import EventsEventSection from "../components/EventSection";
import TeamsListSection from "../components/TeamsListSection";
import UserListSection from "../components/UserListSection";
import { useAuth } from "../hooks/useAuth";

export default function Dashboard() {
  const { user } = useAuth();

  return (
    <div className="flex grow flex-col items-center">
      <div className="flex mt-10 w-full lg:w-3/4">
        <UserListSection pageSize={3} />
      </div>
      <div className="flex mt-10 w-full lg:w-3/4">
        <EventsEventSection pageSize={3} />
      </div>
      {/* Teams */}
      <div className="flex mt-10 w-full lg:w-3/4">
        <TeamsListSection pageSize={3} />
      </div>
    </div>
  );
}
